import { render } from "./BlListFilterMatchNumber.vue?vue&type=template&id=cbd54fd2&scoped=true"
import script from "./BlListFilterMatchNumber.vue?vue&type=script&lang=js"
export * from "./BlListFilterMatchNumber.vue?vue&type=script&lang=js"

import "./BlListFilterMatchNumber.vue?vue&type=style&index=0&id=cbd54fd2&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd54fd2"]])

export default __exports__